<div class="cemetery-container">
  <header class="page-header">
    <i class="material-icons header-icon">info</i>
    <h1>Partnerfriedhöfe</h1>
    <p class="subtitle">Anträge, Preise, Services</p>
  </header>

  <div class="cemetery-list">
    <div *ngFor="let cemetery of cemeteries" 
         class="cemetery-card"
         [class.active]="isSelected(cemetery.id)"
         (click)="selectCemetery(cemetery.id)">
      
      <div class="cemetery-header">
        <div class="header-content">
          <i class="material-icons cemetery-icon">info</i>
          <h2>{{ cemetery.name }}</h2>
                </div>
        <button class="expand-button">
          <i class="material-icons">{{ isSelected(cemetery.id) ? 'expand_less' : 'expand_more' }}</i>
        </button>
                        </div>
                     
      <div class="cemetery-content" *ngIf="isSelected(cemetery.id)">
        <div class="description">
          <i class="material-icons section-icon">description</i>
          <p>{{ cemetery.description }}</p>
                        </div>

        <div class="location-info" *ngIf="cemetery.location">
          <div class="section-header">
            <i class="material-icons section-icon">place</i>
            <h3>Erreichbarkeit</h3>
                        </div>
          <ul>
            <li *ngFor="let city of cemetery.location.nearbyCities">
              <i class="material-icons list-icon">directions_car</i>
              {{ city.name }} ({{ city.distance }})
            </li>
          </ul>
                        </div>
                    
        <div class="features" *ngIf="cemetery.features?.length">
          <div class="section-header">
            <i class="material-icons section-icon">check_circle</i>
            <h3>Ausstattung</h3>
                        </div>
          <ul>
            <li *ngFor="let feature of cemetery.features">
              <i class="material-icons list-icon">check</i>
              {{ feature }}
            </li>
          </ul>
                        </div>

        <div class="documents">
          <div class="section-header">
            <i class="material-icons section-icon">folder</i>
            <h3>Dokumente & Downloads</h3>
                        </div>
          <div class="document-categories">
            <div class="document-category">
              <h4>Anträge & Formulare</h4>
              <div class="document-list">
                <div *ngFor="let doc of cemetery.documents" class="document-item">
                  <a [href]="doc.downloadUrl" target="_blank" class="document-link">
                    <i class="material-icons">file_download</i>
                    <div class="document-info">
                      <span class="document-title">{{ doc.title }}</span>
                      <span *ngIf="doc.stand" class="valid-stand">
                        <i class="material-icons">info</i>
                        Stand {{ doc.stand }}
                      </span>
                      <span *ngIf="doc.validFrom && !doc.stand" class="valid-from">
                        <i class="material-icons">event</i>
                        Gültig ab {{ doc.validFrom }}
                      </span>
                      <span *ngIf="doc.validUntil" class="valid-until">
                        <i class="material-icons">event_busy</i>
                        Gültig bis {{ doc.validUntil }}
                      </span>
                    </div>
                  </a>
                </div>
                    </div>
                </div>

            <div class="document-category" *ngIf="cemetery.priceList || cemetery.priceList2026 || cemetery.priceList2026DFG">
              <h4>Preislisten</h4>
              <div class="document-list">
                <div class="document-item" *ngIf="cemetery.priceList">
                  <a [href]="cemetery.priceList.downloadUrl" target="_blank" class="document-link">
                    <i class="material-icons">file_download</i>
                    <div class="document-info">
                      <span class="document-title">{{ cemetery.priceList.title }}</span>
                      <span *ngIf="cemetery.priceList.validFrom" class="valid-from">
                        <i class="material-icons">event</i>
                        Gültig ab {{ cemetery.priceList.validFrom }}
                      </span>
                      <span *ngIf="cemetery.priceList.validUntil" class="valid-until">
                        <i class="material-icons">event_busy</i>
                        Gültig bis {{ cemetery.priceList.validUntil }}
                      </span>
                    </div>
                  </a>
                </div>
                <div class="document-item" *ngIf="cemetery.priceList2026">
                  <a [href]="cemetery.priceList2026.downloadUrl" target="_blank" class="document-link">
                    <i class="material-icons">file_download</i>
                    <div class="document-info">
                      <span class="document-title">{{ cemetery.priceList2026.title }}</span>
                      <span *ngIf="cemetery.priceList2026.validFrom" class="valid-from">
                        <i class="material-icons">event</i>
                        Gültig ab {{ cemetery.priceList2026.validFrom }}
                      </span>
                    </div>
                  </a>
                </div>
                <div class="document-item" *ngIf="cemetery.priceList2026DFG">
                  <a [href]="cemetery.priceList2026DFG.downloadUrl" target="_blank" class="document-link">
                    <i class="material-icons">file_download</i>
                    <div class="document-info">
                      <span class="document-title">{{ cemetery.priceList2026DFG.title }}</span>
                      <span *ngIf="cemetery.priceList2026DFG.validFrom" class="valid-from">
                        <i class="material-icons">event</i>
                        Gültig ab {{ cemetery.priceList2026DFG.validFrom }}
                      </span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
                    
            <div class="document-category" *ngIf="cemetery.flyer">
              <h4>Informationsmaterial</h4>
              <div class="document-list">
                <div class="document-item">
                  <a [href]="cemetery.flyer.downloadUrl" target="_blank" class="document-link">
                    <i class="material-icons">file_download</i>
                    <span>{{ cemetery.flyer.title }}</span>
                            </a>
                        </div>
                    </div>
                </div>

            <div class="document-category" *ngIf="hasOnlineOrder(cemetery)">
              <h4>Online-Services</h4>
              <div class="document-list">
                <div class="document-item">
                  <a href="dash/burials" ui-sref="dash.burials" class="online-order">
                    <i class="material-icons">computer</i>
                    <span>Online-Auftrag</span>
                  </a>
                </div>
                        </div>
                    </div>
                </div>
                        </div>
                     
        <div class="online-info" *ngIf="cemetery.onlineUrl">
          <div class="section-header">
            <i class="material-icons section-icon">language</i>
            <h3>Weitere Informationen</h3>
                        </div>
          <p>Besuchen Sie unsere <a [href]="cemetery.onlineUrl" target="_blank">Webseite</a> für detaillierte Informationen.</p>
                        </div>
                    </div>
                </div>
    </div>
</div>
